import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRouter from "./routes/AppRouter";
import "../src/assets/stylesheets/main.scss";
import { keepTheme } from "./utils/themes";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store";
import "../src/assets/stylesheets/vendor/bootstrap.min.css";
import { ReactNotifications } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const createHistory = require("history");

function App() {
  keepTheme();
  return (
    <>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router history={createHistory}>
            <ReactNotifications />
            <AppRouter />
          </Router>
        </PersistGate>
      </Provider>
    </>
  );
}

export default App;
